var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkySavingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20c0-1.375 1.125-2.5 2.5-2.5s2.5 1.125 2.5 2.5-1.125 2.5-2.5 2.5a2.507 2.507 0 01-2.5-2.5zM15 17.5h12.5v-5H15v5zm35-3.75v17.425l-7.05 2.35-4.2 13.975H25v-5h-5v5H6.25S0 26.35 0 18.75C0 11.15 6.15 5 13.75 5h12.5c2.275-3.025 5.9-5 10-5A3.745 3.745 0 0140 3.75c0 .525-.1 1-.3 1.45-.35.85-.65 1.825-.8 2.875l5.675 5.675H50zm-5 5h-2.5L33.75 10c0-1.625.225-3.225.65-4.775A7.54 7.54 0 0029.175 10H13.75C8.925 10 5 13.925 5 18.75c0 4.7 3.05 16.625 5.025 23.75H15v-5h15v5h5.025L38.9 29.625l6.1-2.05V18.75z",
    fill: "#006DFF"
  })));
}
export default SvgSkySavingIcon;